import { render, staticRenderFns } from "./data_statistics.vue?vue&type=template&id=feaa99ce&scoped=true"
import script from "./data_statistics.vue?vue&type=script&lang=js"
export * from "./data_statistics.vue?vue&type=script&lang=js"
import style0 from "./data_statistics.vue?vue&type=style&index=0&id=feaa99ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feaa99ce",
  null
  
)

export default component.exports